import React, { useContext } from "react";
import { FaBolt } from "react-icons/fa";
import COLORS from "scss/colors.module.scss";
import { observer, useObserver } from "mobx-react";
import styled, { css } from "styled-components";

import { ContainerStoreContext } from "../ContainerStore";

function Triggers({ handleClose = () => {} }) {
  const { listId, listColumns, listName, viewId, containerStore } = useData();

  return (
    <StyledTriggerDiv
      className="d-flex"
      onClick={() => {
        handleClose();
        const notificationsWin = Ext.create("TL.Window", {
          title: "Workflows",
          modal: true,
          width: 1000,
          height: Ext.getBody().getViewSize().height - 50,
          layout: "fit",
          cls: "tl-window workflows-win",
          helpLinkIdentifier: "triggers",
          items: [Ext.create("TL.list.events.HandlersRegistrationPanel", {
              cls: "workflows-ct",
              autoHeight: true,
              anchor: "100%",
              border: false,
              viewId: viewId,
              //config: this.config,
              currentList: {
                id: listId,
                name: listName,
                columns: listColumns,
              },
              listeners: {
                  close: function () {
                      notificationsWin.close();
                  },
                  addevent: async function () {
                      //this.fireEvent('reloadsheet', this);
                      //viewPort.loadGridComponent(this.config.list.id);
                      await containerStore.loadGrid();
                  },
                  deleteevent: async function () {
                      //this.fireEvent('reloadsheet', this);
                      //viewPort.loadGridComponent(this.config.list.id);
                      await containerStore.loadGrid();
                  },
                  scope: this
              }
          })],
          listeners: {
              /*'show': function () {
                  TL.help.HintsService.showHints(TL.help.HintsService.EVENT_WORKFLOW_LOADED, {});
              },*/
              'close': function () {
                  setTimeout(function () {
                      TL.help.HintsService.showHints(TL.help.HintsService.EVENT_WORKFLOW_CLOSED, {});
                  }, 500);
              }
          }
        });

        notificationsWin.show();
      }}
    >
      <IconWrapper>
        <FaBolt size={18} color={COLORS.TEXT_COLOR} />
      </IconWrapper>
      Triggers
    </StyledTriggerDiv>
  );
}

function useData() {
  const containerStore = useContext(ContainerStoreContext);
  const listConfig = containerStore.listConfig;

  return useObserver(() => ({
    listId: containerStore.listId,
    listColumns: listConfig?.listData,
    listName: listConfig?.list.name,
    viewId: containerStore.view?.id,
    containerStore: containerStore
  }));
}

export default observer(Triggers);

const StyledTriggerDiv = styled.div`
  cursor: pointer;
  padding: 6px 16px;
  align-items: center;
  line-height: 20px;
  white-space: nowrap;
  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

const IconWrapper = styled.div`
  margin-right: 15px;
`;